import { ComponentType } from "react";
import z from "zod";
import type { ConfigFormProps } from "view/dashboard/widgets/sources/types";
import type { WidgetValueType, WidgetValueTypes } from "view/dashboard/types/widget";

export type WidgetVisual<Type extends WidgetValueType, Config,> = {
	valueType: Type;
	label: string;
	configSchema: z.ZodType<Config>;
	form: ComponentType<ConfigFormProps>;
	render: ComponentType<{ value: WidgetValueTypes[Type]; config: Config }>;
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export type RegisteredVisual = { [K in WidgetValueType]: WidgetVisual<K, any> }[WidgetValueType];
export type ResolvedVisual = WidgetVisual<WidgetValueType, any>;

export const createWidgetVisual = <K extends WidgetValueType, Config,>(visual: WidgetVisual<K, Config>) => visual;
